/* ################################################################### */
/* FUNCTION (MODAL WINDOW) ########################################### */
/* ################################################################### */
function modalWindow(speed, ease)
{
	jQuery('.js-modal_trigger').on('click', function(e)
	{
		e.preventDefault();

		var jQuery_this = jQuery(this);
			idModal     = jQuery_this.attr('data-modal');

		openCloseModalwindow(idModal);
	});
}

function openCloseModalwindow(idModal)
{
	if(jQuery(idModal).hasClass('open'))
	{
		console.log('close');

		jQuery(idModal).removeClass('open');
		document.body.style.overflow = "";
	}
	else
	{
		console.log('open');

		jQuery(idModal).addClass('open');
		document.body.style.overflow = "hidden";
	}

	jQuery(idModal).stop(true, true).fadeToggle(speed, ease);

	checkModalHeight(idModal);
	jQuery(window).bind('resizeEnd', function(){ checkModalHeight(idModal) });
}

function checkModalHeight(idModal)
{
	var thisModal     = jQuery(idModal);
		modalContent  = jQuery('.content', idModal);
		hModalContent = modalContent.outerHeight(true);
		hBody         = jQuery('body').height();

	if(jQuery(window).width() > 768)
	{
		if(hModalContent >= hBody)
			thisModal.addClass('fixedHeight');
		else
			thisModal.removeClass('fixedHeight');
	}
}
